<template>
  <span>{{ dateValue }}</span>
</template>

<script>
  import methods from '../../utils/methods';

  export default {
    name: 'DateTimeCellIso',

    props: ['date'],

    computed: {
      dateValue: function () {
        return this.date ? `${methods.getDateFromIso(this.date)} ${methods.getTimeFromIso(this.date)}` : '--.--';
      },
    },
  };
</script>

<style scoped>

</style>
